import Vue from 'vue'
import VueSocketIO from 'vue-socket.io';
import App from './App.vue'
import vuetify from './plugins/vuetify'
import moment from './plugins/vue-moment'
import VueProgressBar from './plugins/vue-progressbar'
// import VueSweetalert2 from './plugins/sweetalert2'
import router from './router'
import store from './plugins/vuex';

import './plugins/csp-component';
import './plugins/vue-filter';
import './plugins/Toast';
import './plugins/sweetalert2';
import './plugins/fontAwesome';
// import './plugins/signature';
import './registerServiceWorker';
import './plugins/style';
import './plugins/vue-image-upload-resize';

Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV !== 'production',
    connection: `${process.env.VUE_APP_SERVER_URL}`,
    vuex: {
      store,
      // @ts-ignore
      debug: false,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  }),
);


Vue.config.productionTip = false

new Vue({
  VueProgressBar,
  vuetify,
  moment,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
